import { FC } from 'react';
import { Box, Flex, Palette, Text } from '@updater/ui-uds';
import { TvInternetOffer } from '@updater/consumer-graph';
import { useOfferContext } from '@updater/ui-widgets';
import { ArrowDown, ArrowUp, type Icon } from '@phosphor-icons/react';
import styled from '@emotion/styled';

const SpeedPill = styled(Flex)`
  background-color: ${Palette.blue50};
  border-radius: 12px;
  padding: 16px 24px;
  flex: 1;
`;

const SpeedPillItem: FC<{ Icon: Icon; label: string; value: number }> = ({
  Icon,
  label,
  value,
}) => (
  <SpeedPill flexDirection="column" alignItems="center">
    <Flex alignItems="center" mb="xxs">
      <Icon size={14} color={Palette.gray700} />
      <Text variant="xs" color={Palette.gray700} ml="xxs">
        {label}
      </Text>
    </Flex>
    <Text variant="xxlBold">{value}</Text>
    <Text variant="xs" color={Palette.gray700}>
      MBPS
    </Text>
  </SpeedPill>
);

export const InternetSpeedSection: FC = () => {
  const { products } = useOfferContext() as TvInternetOffer;
  const downloadSpeed = products?.internet?.downloadSpeed?.value;
  const uploadSpeed = products?.internet?.uploadSpeed?.value;

  if (!Boolean(downloadSpeed) && !Boolean(uploadSpeed)) return null;

  return (
    <Box mb="m">
      <Text variant="mBold" mb="s">
        Internet speed
      </Text>
      <Flex gap="s">
        {Boolean(downloadSpeed) && (
          <SpeedPillItem
            Icon={ArrowDown}
            label="Download"
            value={downloadSpeed}
          />
        )}
        {Boolean(uploadSpeed) && (
          <SpeedPillItem Icon={ArrowUp} label="Upload" value={uploadSpeed} />
        )}
      </Flex>
    </Box>
  );
};
